module.exports = __webpack_public_path__ + "static/media/tch_hero.87fec40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/components/Hero/TCHHero/assets/tch_hero.jpg
// module id = 3422
// module chunks = 0